export const HomeTranslation = {
  en: {
    hello: 'Hello'
  },
  pt: {
    hello: 'Olá'
  }
}
